const initialState = [];

const customers = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ALL_ACTIONS":
      state = action.customers || [];
      return state;
    default:
      return state;
  }
};

export default customers;
